export default __webpack_public_path__ + "static/media/BuyNZMade_Logo_Black_Triangle.ec8721c2.svg";